import { Stack, Tooltip } from '@mui/material'
import {
  GRID_CHECKBOX_SELECTION_COL_DEF,
  GridCellCheckboxRenderer,
  GridColDef,
  GridRenderCellParams,
  GridRowModel,
} from '@mui/x-data-grid-premium'
import { createContext, MouseEvent, useContext } from 'react'

export type RowSelectionStatus = { isSelectable: true } | { isSelectable: false; message: string }

export type RowSelectionStatusProp = {
  /**
   * Decides whether each row's checkbox is enabled, and the tooltip message shown when it is not.
   *
   * - Replaces `isRowSelectable`, which is ignored while this is set.
   * - Also called for group rows, which have no `id`, so a grouped table must handle them.
   * - Enable checkboxSelectionVisibleOnly if table has frontend pagination instead of backend
   */
  getRowSelectionStatus?(row: GridRowModel): RowSelectionStatus
}

export const RowSelectionStatusContext = createContext<RowSelectionStatusProp['getRowSelectionStatus']>(undefined)

const preventAdditionalMouseEvents = (event: MouseEvent) => {
  event.stopPropagation()
  if (!(event.target instanceof HTMLInputElement)) event.preventDefault()
}

const RowSelectionCheckboxCell = (params: GridRenderCellParams) => {
  const getRowSelectionStatus = useContext(RowSelectionStatusContext)
  const selectionStatus = getRowSelectionStatus?.(params.row)
  const blockedMessage = selectionStatus?.isSelectable === false ? selectionStatus.message : ''

  return (
    <Tooltip title={blockedMessage}>
      <Stack
        onClick={preventAdditionalMouseEvents}
        sx={{ width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }}
      >
        <GridCellCheckboxRenderer {...params} />
      </Stack>
    </Tooltip>
  )
}

export const ROW_SELECTION_CHECKBOX_COLUMN: GridColDef = {
  ...GRID_CHECKBOX_SELECTION_COL_DEF,
  hideable: false,
  renderCell: (params) => <RowSelectionCheckboxCell {...params} />,
}
